module.exports = __webpack_public_path__ + "img/bnk2.cb3626e8.svg";